import { render, staticRenderFns } from "./AplikasiView.vue?vue&type=template&id=aae126a4&scoped=true"
import script from "./AplikasiView.vue?vue&type=script&lang=js"
export * from "./AplikasiView.vue?vue&type=script&lang=js"
import style0 from "./AplikasiView.vue?vue&type=style&index=0&id=aae126a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae126a4",
  null
  
)

export default component.exports